import type { IconButtonProps } from '@mui/material/IconButton';

import { m } from 'framer-motion';

import IconButton from '@mui/material/IconButton';

import { varTap, varHover, AnimateBorder, transitionTap } from 'src/components/animate';
import { IConsulenteItem, IUserItem } from '../../types/user';
import {UserAvatar} from "../../components/avatar/avatar";

// ----------------------------------------------------------------------

export type AccountButtonProps = IconButtonProps & {
  user: IUserItem | IConsulenteItem;
};

export function AccountButton({ user, sx, ...other }: AccountButtonProps) {
  const displayName = `${user?.name ?? ''} ${user?.lastname ?? ''}`.trim();

  return (
    <IconButton
      component={m.button}
      whileTap={varTap(0.96)}
      whileHover={varHover(1.04)}
      transition={transitionTap()}
      aria-label="Account button"
      sx={[{ p: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      <AnimateBorder
        sx={{ p: '3px', borderRadius: '50%', width: 40, height: 40 }}
        slotProps={{
          primaryBorder: { size: 60, width: '1px', sx: { color: 'primary.main' } },
          secondaryBorder: { sx: { color: 'warning.main' } },
        }}
      >
        <UserAvatar
          row={{
            name: user?.name,
            lastname: user?.lastname,
            avatarPath: user?.avatarPath,
          }}
          size={34}
        />
      </AnimateBorder>
    </IconButton>
  );
}
